import brands from '@/brands/brands.js';


export function brandDetector() {


    var domain = location.host;


    var brandsIndex = {
        'portal-uax.dev.doubledot.es': 'uax',
        'empleo.uax.es': 'uax',

        'demo-front.dotia.es': 'dotia',

        'portal-comillas.dev.doubledot.es': 'comillas',

        'portal-uc3m.dev.doubledot.es': 'uc3m',
        'portal-uc3m-dev.dotia.es' : 'uc3m',
        'portal-uc3m.dotia.es' : 'uc3m', // PRO
        'empleoypracticas.uc3m.es'  : 'uc3m', // PRO
        
        'portal-uva.dev.doubledot.es': 'uva',
        'portal.uvaempleo.com': 'uva',

        'portal-uib.dev.doubledot.es': 'uib',
        'doipcandidats.fueib.org': 'uib',
        'traducciones-uib.dev.doubledot.es': 'uib',
        
        
        'localhost:8080': 'uc3m',
       'localhost:8081': 'uax',
        "192.168.1.184:8080": "uax",
    };

    var selected = brandsIndex[domain];

    //SETEO DE LOS FAVICONS

    if (!!selected) {

        if (!!brands[selected].hasFavicon) {

            var url = '/static/img/brands/' + selected + '/favicon/';

            document.head.querySelector("[name=big-favicon]").href = url + 'apple-touch-icon.png';
            document.head.querySelector("[name=medium-favicon]").href = url + 'favicon-32x32.png';
            document.head.querySelector("[name=small-favicon]").href = url + 'favicon-16x16.png';
            document.head.querySelector("[name=favicon]").href = url + 'favicon.ico';
            document.head.querySelector("[name=msapplication-config]").href = url + 'browserconfig.xml';
            document.head.querySelector("[name=webmanifest]").href = url + 'site.webmanifest';

        }

        return brands[selected];


    } else {
        return brands['dotia'];
    }

}


// WEBPACK FOOTER //
// ./src/brands/index.js